<template>
  <div :style="activeTab === 3 ? { paddingBottom: '70px' } : {}">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <!-- Tab 切換 -->
    <div class="pt-4 px-4 pb-4" style="background-color: #fff;">
      <div class="d-flex mb-0" style="border: 1px solid #777; border-radius: 8px; overflow: hidden; height: 40px; background: #fff; box-shadow: none !important;">
        <div class="flex-grow-1 text-center" style="border-radius: 6px" @click="changeTab(0)"
        :style="{ backgroundColor: activeTab === 0 ? '#4C4948' : 'transparent', color: activeTab === 0 ? 'white' : '#333', cursor: 'pointer', lineHeight: '38px', fontWeight: 'bold' }">
          {{$t('__Organization')}}
        </div>
        <div class="flex-grow-1 text-center" style="border-radius: 6px" @click="changeTab(1)"
        :style="{ backgroundColor: activeTab === 1 ? '#4C4948' : 'transparent', color: activeTab === 1 ? 'white' : '#333', cursor: 'pointer', lineHeight: '38px', fontWeight: 'bold' }">
          {{$t('__Staff')}}
        </div>
        <div class="flex-grow-1 text-center" style="border-radius: 6px" @click="changeTab(2)"
        :style="{ backgroundColor: activeTab === 2 ? '#4C4948' : 'transparent', color: activeTab === 2 ? 'white' : '#333', cursor: 'pointer', lineHeight: '38px', fontWeight: 'bold' }">
          {{$t('__Customer')}}
        </div>
        <div class="flex-grow-1 text-center" style="border-radius: 6px" @click="changeTab(3)"
        :style="{ backgroundColor: activeTab === 3 ? '#4C4948' : 'transparent', color: activeTab === 3 ? 'white' : '#333', cursor: 'pointer', lineHeight: '38px', fontWeight: 'bold' }">
          {{$t('__Config')}}
        </div>
      </div>
    </div>

    <!-- 內容 -->
    <v-row v-if="(activeTab !== 3) && displayMode === 0" class="text-left search-bar search-bar-max ma-0">
      <v-col cols="7" class="pl-8 pr-0">
        <v-row>
          <v-col class="pa-0 col-5">
            <v-text-field outlined :placeholder="$t('__keywordSearch')" class="keyword text_field"
            dense v-model="keyword" background-color="white" style="margin-top: 4px" @keyup.enter="search">
              <template v-slot:append>
                <v-icon class="my-1" color="white" style="background:#ED6D00" @click="search">
                icon-form_search
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
            <v-icon color="white" size="20">mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="5" class="pr-8 pl-0">
        <v-row justify="end" align="center">
          <!-- Export Excel (Organization & Staff only) -->
          <v-btn v-if="canEdit && (activeTab === 0 || activeTab === 1)" class="ma-1 pa-0" outlined :title="$t('__exportExcel')"
            style="border:none; height:34px; min-width:40px; border-radius: 8px; background:#ED6D00"
            @click="exportExcel">
            <v-icon color="white" size="22">mdi-cloud-download-outline</v-icon>
          </v-btn>
          <!-- Import Excel (Organization & Staff only) -->
          <v-btn v-if="canEdit && (activeTab === 0 || activeTab === 1)" class="ma-1 pa-0" outlined :title="$t('__importExcel')"
            style="border:none; height:34px; min-width:40px; border-radius: 8px; background:#ED6D00"
            @click="$refs.ImportFile.open((activeTab === 0 ? 'organization' : 'staff'),true)">
            <v-icon color="white" size="20">mdi-cloud-upload-outline</v-icon>
          </v-btn>
          <v-btn v-if="canEdit && activeTab === 0" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath(-1)">
            <span>{{$t('__newOrganization')}}</span>
          </v-btn>
          <v-btn v-if="canEdit && activeTab === 1" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath(-1)">
            <span>{{$t('__newStaff')}}</span>
          </v-btn>
          <v-btn v-if="canEdit && activeTab === 2" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath(-1)">
            <span>{{$t('__newCustomer')}}</span>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <!-- 子頁籤 (僅在 Config 頁籤顯示) -->
    <v-row v-if="activeTab === 3" class="text-left search-bar">
      <v-col class="pt-0 pl-4 col-12">
        <v-tabs class="tabsLeft" color="#ED6D00" v-model="tab">
          <v-tabs-slider class="primary-color"></v-tabs-slider>
          <v-tab>{{$t('__trackStatus')}}</v-tab>
          <v-tab>{{$t('__maintenanceReason')}}</v-tab>
          <v-tab>{{$t('__managerMail')}}</v-tab>
          <v-tab>{{$t('__expiryReminder')}}</v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row v-if="(activeTab !== 3) && displayMode === 1" class="text-left search-bar ma-0 pa-0 search-bar-min">
      <v-expansion-panels accordion style="z-index: 3">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-icon class="ml-0 mr-3">icon-form_search</v-icon>
            {{$t('__categorySearch')}}
            <template v-slot:actions>
              <v-icon>$expand</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <v-row justify="center">
                <v-col class="pa-0 col-7">
                  <v-text-field outlined :placeholder="$t('__keywordSearch')" class="keyword text_field"
                  dense v-model="keyword" background-color="white" style="margin-top: 4px" @keyup.enter="search">
                    <template v-slot:append>
                      <v-icon class="my-1" color="white" style="background:#ED6D00" @click="search">
                      icon-form_search
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
                  <v-icon color="white" size="20">mdi-close</v-icon>
                </v-btn>
              </v-row>
              <v-divider class="d-md-none"></v-divider>
              <v-row class="justify-center pt-1">
                <v-btn v-if="canEdit && activeTab === 0" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath(-1)">
                  <span>{{$t('__newOrganization')}}</span>
                </v-btn>
                <v-btn v-if="canEdit && activeTab === 1" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath(-1)">
                  <span>{{$t('__newStaff')}}</span>
                </v-btn>
                <v-btn v-if="canEdit && activeTab === 2" class="search-bar-btn" style="color:#FFF" outlined @click="redirectPath(-1)">
                  <span>{{$t('__newCustomer')}}</span>
                </v-btn>
              </v-row>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <v-row id="router" class="ma-0 pa-0">
      <!-- 列表 (非 Config 頁籤) -->
      <div v-if="activeTab !== 3" id="listTable" style="width: 100%">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr class="text-center" v-if="activeTab === 0">
                <th class="text-center">{{$t('__edit')}}</th>
                <th @click="sort('id')">{{$t('__no')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th style="min-width:140px" @click="sort('groupName')">{{$t('__groupName')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th style="min-width:140px" @click="sort('vatNumber')">{{$t('__vatNumber')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('nation')">{{$t('__orgNation')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th style="min-width:140px" @click="sort('address')">{{$t('__address')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('tel')">{{$t('__tel')}}<v-icon small>icon-form_sort_off</v-icon></th>
              </tr>
              <tr class="text-center" v-if="activeTab === 1">
                <th class="text-center">{{$t('__edit')}}</th>
                <th @click="sort('id')">{{$t('__no')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('name')">{{$t('__staffName')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('employeeId')">{{$t('__empId')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('title')">{{$t('__title')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('group')">{{$t('__group')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('role')">{{$t('__role')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('account')">{{$t('__email')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('phone')">{{$t('__tel')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('mobile')">{{$t('__mobile')}}<v-icon small>icon-form_sort_off</v-icon></th>
              </tr>
              <tr class="text-center" v-if="activeTab === 2">
                <th class="text-center">{{$t('__edit')}}</th>
                <th @click="sort('id')">{{$t('__no')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('name')">{{$t('__customerName')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('contactPerson')">{{$t('__contactPerson')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('phoneNumber')">{{$t('__tel')}}<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('emailAddress')">{{$t('__email')}}<v-icon small>icon-form_sort_off</v-icon></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index" id="table_body" :class="{'disabled-row': activeTab === 1 && data.status == '2'}">
                <td class="text-center" :style="(activeTab === 0 || activeTab === 1 || activeTab === 2) ? 'min-width:120px' : 'min-width:75px'">
                  <v-row class="ma-0 justify-center">
                    <div class="mr-1" style="min-width:30px;max-width:30px;height:30px">
                      <v-avatar color="#ED6D00" size="30" tile @click="redirectPath(data.encryptedId || data.id)"
                        class="action-btn-edit" style="cursor: pointer;">
                        <v-icon color="#FFFFFF" :size="(activeTab === 1 && data.status == '2') ? '20' : ''">{{ (activeTab === 1 && data.status == '2') ? 'mdi-eye-outline' : 'icon-form_edit_tap' }}</v-icon>
                      </v-avatar>
                    </div>
                    <div style="min-width:30px;max-width:30px;height:30px">
                      <v-avatar v-if="canEdit && (activeTab === 0 || (activeTab === 1 && data.status != '2') || activeTab === 2)" color="#4C4948" size="30" tile @click="confirmDelete(data.id)"
                        class="action-btn-delete" style="cursor: pointer;">
                        <v-icon color="#FFFFFF">mdi-delete</v-icon>
                      </v-avatar>
                    </div>
                  </v-row>
                </td>
                <template v-if="activeTab === 0">
                  <td style="min-width:95px"><h4 class="content">{{data.id}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.groupName}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.vatNumber}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.nation}}</h4></td>
                  <td style="min-width:130px"><h4 class="content">{{data.address}}</h4></td>
                  <td style="min-width:100px"><h4 class="content">{{data.tel}}</h4></td>
                </template>
                <template v-if="activeTab === 1">
                  <td style="min-width:95px"><h4 class="content">{{data.id}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.name}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.employeeId}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.title}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.group}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.role}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.account}}</h4></td>
                  <td style="min-width:130px"><h4 class="content">{{data.phone}}</h4></td>
                  <td style="min-width:130px"><h4 class="content">{{data.mobile}}</h4></td>
                </template>
                <template v-if="activeTab === 2">
                  <td style="min-width:95px"><h4 class="content">{{data.id}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.name}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.contactPerson}}</h4></td>
                  <td style="min-width:120px"><h4 class="content">{{data.phoneNumber}}</h4></td>
                  <td style="min-width:130px"><h4 class="content">{{data.emailAddress}}</h4></td>
                </template>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <!-- Track Status Management (Config Tab) -->
      <v-row v-if="activeTab === 3" class="ma-0 pa-0" style="width: 100%">
        <!-- Left Panel: List -->
        <v-col class="pa-0 col-12 col-lg-6">
          <v-row class="ma-0">
            <div id="listTable" style="width: 100%">
              <!-- List of items with header -->
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 15%">{{ $t('__no') }}</th>
                      <th class="text-left" style="width: 55%">{{ subTabLabel }}</th>
                      <th class="text-right" style="width: 30%; padding-right: 16px">
                        <v-btn v-if="canEdit && tab !== 3" class="search-bar-btn" style="color:#FFF" outlined @click="addNewItem"><span>{{$t('__newItem')}}</span></v-btn>
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="codeTypeList.length > 0">
                    <tr 
                      v-for="(item, index) in codeTypeList" 
                      :key="item.id"
                      :class="{ 'orange-row': selectedItemIndex === index }"
                      style="cursor: pointer; border-bottom: 1px solid #eee"
                    >
                      <td class="text-left" style="width: 15%">{{ index + 1 }}</td>
                      <td class="text-left" style="width: 55%">{{ (tab == 1 && language == 'tw') ? item.CodeValue : item.CodeText}}</td>
                      <td class="text-right" style="width: 30%; padding-right: 16px">
                        <v-avatar 
                          color="#ED6D00" 
                          size="32" 
                          tile 
                          @click="selectItem(index)" 
                          style="margin-right: 8px; cursor: pointer; border-radius: 8px">
                          <v-icon color="#FFFFFF" size="28">icon-form_edit_tap</v-icon>
                        </v-avatar>
                        <v-avatar 
                          v-if="canEdit && tab !== 3"
                          color="#4C4948" 
                          size="32" 
                          tile 
                          @click="confirmDeleteItem(item.id)" 
                          :style="{ 
                            borderRadius: '8px',
                            cursor: 'pointer',
                            visibility: (tab === 0 && (item.CodeText === 'New' || item.CodeText === 'Closed')) ? 'hidden' : 'visible'
                          }"
                        >
                          <v-icon color="white" size="18">mdi-delete</v-icon>
                        </v-avatar>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-row>
        </v-col>

        <!-- Right Panel: Edit Form -->
        <v-col class="pa-0 col-12 col-lg-6">
          <v-row class="ma-0">
            <div v-if="selectedItemIndex !== -1" id="box2" class="pa-5">
              <v-row class="pb-3">
                <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
                <h4 v-if="selectedItemIndex === 99999" class="primary-color" style="padding-top:2px">{{ $t('__newItem') }}</h4>
                <h4 v-else class="primary-color" style="padding-top:2px">{{ $t('__editItem') }}</h4>
              </v-row>
              
              <!-- Field 1: CodeText -->
              <v-row class="ma-0 mb-3">
                <v-col class="col-12 pa-0">
                  <div class="text-left pb-2" style="font-weight: 600">
                    <span class="start">* </span>{{ field1Label }}
                  </div>
                    <v-text-field
                      v-model="editingItem.CodeText"
                      outlined
                      dense
                      :placeholder="field1Label"
                      hide-details
                      :readonly="tab === 3 || !canEdit || (selectedItemIndex !== 99999 && tab === 0 && (editingItem.CodeText === 'New' || editingItem.CodeText === 'Closed'))"
                      :background-color="tab === 3 || !canEdit || (selectedItemIndex !== 99999 && tab === 0 && (editingItem.CodeText === 'New' || editingItem.CodeText === 'Closed'))?'#F4F8F9':'#FFF'"
                    ></v-text-field>
                </v-col>
              </v-row>

              <!-- Field 2: CodeValue -->
              <v-row class="ma-0 mb-3">
                <v-col class="col-12 pa-0">
                  <div class="text-left pb-2" style="font-weight: 600">
                    <span class="start">* </span>{{ field2Label }}
                  </div>
                  <v-row class="ma-0" style="align-items: center; position: relative">
                    <v-col :class="tab === 0 ? 'col-10' : 'col-12'" class="pa-0" style="position: relative">
                      <v-text-field
                        v-model="editingItem.CodeValue"
                        outlined
                        dense
                        :placeholder="field2Label"
                        background-color="white"
                        hide-details
                        :readonly="tab === 0 || !canEdit"
                        :style="(tab === 0 && canEdit) ? { cursor: 'pointer' } : {}"
                        @click="(tab === 0 && canEdit) ? openColorPicker() : null"
                      ></v-text-field>
                    </v-col>
                    <v-col v-if="tab === 0" class="col-2 pa-0 pl-2" style="position: relative">
                      <div 
                        :style="{ 
                          width: '40px', 
                          height: '40px', 
                          backgroundColor: editingItem.CodeValue || '#FFFFFF',
                          border: '2px solid #ccc',
                          borderRadius: '50%',
                          cursor: canEdit ? 'pointer' : 'default',
                          boxShadow: '0 1px 4px rgba(0,0,0,0.2)'
                        }"
                        @click="canEdit ? openColorPicker() : null"
                      ></div>
                      <!-- Hidden native color picker -->
                      <input
                        ref="nativeColorPicker"
                        type="color"
                        :value="editingItem.CodeValue || '#FFFFFF'"
                        @input="onColorPickerChange"
                        style="position: absolute; opacity: 0; width: 0; height: 0; pointer-events: none;"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Description (readonly) -->
              <v-row class="ma-0 mb-3">
                <v-col class="col-12 pa-0">
                  <div class="text-left pb-2" style="font-weight: 600">{{$t('__description')}}</div>
                  <textarea class="pa-2 pt14" rows="5" readonly style="background-color: #F4F8F9" v-model="editingItem.CodeMemo1"></textarea>
                </v-col>
              </v-row>
            </div>
          </v-row>
        </v-col>
      </v-row>
    
      <v-row v-if="activeTab !== 3" class="ma-0 px-4 justify-center justify-lg-end">
        <v-col cols="12" lg="6" class="pa-0"></v-col>
        <v-col cols="12" lg="6">
          <v-row class="ma-0 align-center" style="justify-content: center">
            <v-col cols="12" lg="auto" class="d-none d-lg-flex align-center">
              {{ $tc('__totalCount', pagination.totalCount, { count: pagination.totalCount }) }}
            </v-col>
            <v-col cols="12" lg="auto" class="d-flex justify-center">
              <v-pagination color="#ED6D00" :total-visible="5" :length="pagination.totalPage" v-model="pagination.page"/>
            </v-col>
            <v-col cols="12" lg="auto" class="d-flex justify-center justify-lg-end align-center">
              <span class="mr-2">{{ $t('__go') }}</span>
              <v-text-field class="mx-1 text-center" min="1" :max="pagination.totalPage" type="number"
              dense outlined hide-details style="max-width: 80px" @keyup.enter="setDestPage()" v-model="destPage"/>
              <span class="ml-1">{{ $t('__page') }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <!-- Save Button for Config Tab -->
    <v-footer v-if="activeTab === 3" id="footer" class="fixed-footer">
      <div class="text-center mx-auto footer" style="height:44px">
        <v-btn v-if="canEdit" class="btn" large color="#ED6D00" style="color: #FFF; box-shadow:none" @click="save()">{{$t('__save')}}</v-btn>
      </div>
    </v-footer>
    <ImportFile ref="ImportFile" :onSave="onImportFile" />
    <ShowConfirm ref="ShowConfirm" :onSave="deleteRecord" />
    <ShowMsg ref="ShowMsg" />

    <!-- Import Result Dialog -->
    <v-dialog v-model="showImportResult" max-width="500" persistent>
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="top: 22px">
          <v-icon color="#D8DDE4" @click="showImportResult = false">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{ $t('__importResultTitle') }}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; font-size:15px">
          {{ importResultMessage }}
          <div v-if="importResultData && importResultData.errors && importResultData.errors.length > 0" class="mt-3">
            <div style="color:#ED6D00; margin-bottom:4px;">{{ $t('__importErrors') }}</div>
            <div v-for="(err, idx) in importResultData.errors" :key="idx" style="color:#b71c1c; font-size:13px;">{{ err }}</div>
          </div>
        </v-card-text>
        <v-row justify="center">
          <v-card-actions class="mb-2 px-3" style="justify-content:center">
            <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="showImportResult = false; getDataset();">
              {{ $t('__confirm') }}
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ImportFile from '@/dialogs/ImportFile'
import ShowConfirm from '@/dialogs/ShowConfirm'
import ShowMsg from '@/dialogs/ShowMsg'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import { getEmployeeInfo } from '@/utils/auth'

export default {
  name: 'Configuration',
  components: {ImportFile, ShowConfirm, ShowMsg, Loading},
  mounted(){
    this.language = i18n.locale
    
    // Restore tab: priority URL query > sessionStorage
    if (this.$route.query.tab !== undefined) {
      this.activeTab = parseInt(this.$route.query.tab)
      sessionStorage.setItem('configTab', this.activeTab)
    } else {
      const savedTab = sessionStorage.getItem('configTab')
      if (savedTab !== null) {
        this.activeTab = parseInt(savedTab)
      }
    }
    
    this.getDataset()
    this.destPage = this.pagination.page
  },
  data:() => ({
    activeTab: 0,
    tab: 0,
    select:'',
    keyword:'',
    language:'tw',
    datasets: [],
    pagination:{page:1,totalPage:1,totalCount:0},
    pageSize: 10,
    orderBy:'id',
    direction:'desc',
    destPage:'',
    viewStyle:{},
    viewStyleTab3:{},
    displayMode:'',

    languageList: [],
    memberStatusSel:'',


    // Config Tab (CodeType Management)
    codeTypeList: [],
    selectedItemIndex: -1, 
    editingItem: {
      id: 0,
      CodeType: '',
      OrderSeq: 1,
      CodeText: '',
      CodeValue: ' ',
      CodeMemo1: 'Track status and color (e.g., #FFFF00)',
      CodeMemo2: '',
      CodeMemo3: '',
      CodeMemo4: '',
      CodeMemo5: ''
    },
    
    // Legacy Config Tab (CommonProblem style - to be removed or repurposed)
    contentList: [],
    curIdxChapter: -1,
    curIdxSection: -1,
    isLoading: false,
    deleteId: null,

    // Excel import result
    showImportResult: false,
    importResultMessage: '',
    importResultData: null,
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
    this.$root.$on('language',(value)=>{
      this.language = value
    })
  },
  watch:{
    "pagination.page":function(val){
      this.destPage = val
      this.getDataset()
    },
    "memberStatusSel":function(){
      this.getDataset()
    },
    "keyword":function(){
      this.getDataset()
    },
    "tab":function(){
      this.curIdxChapter = -1
      this.curIdxSection = -1
      this.selectedItemIndex = -1 // Reset CodeType selection
      this.getDataset()
    },
    "language":function(){
      this.changeListSel(this.languageList)
      this.getDataset()
      this.curIdxChapter = -1
      this.curIdxSection = -1
    },
  },
  computed: {
    canEdit() {
      try {
        const info = getEmployeeInfo()
        if (info && info.function) {
          const perms = JSON.parse(info.function)
          const p = perms.find(e => e.key === 'Configuration')
          return p ? !!p.edit : false
        }
      } catch (e) {
        console.error('Failed to parse permissions:', e)
      }
      return false
    },
    subTabLabel() {
      switch(this.tab) {
        case 0: return this.$t('__trackStatus');
        case 1: return this.$t('__maintenanceReason');
        case 2: return this.$t('__managerName');
        case 3: return this.$t('__expirationReminderType');
        default: return '';
      }
    },
    codeTypeKey() {
      switch(this.tab) {
        case 0: return 'TrackStatus';
        case 1: return 'MaintenanceReason';
        case 2: return 'ManagerMail';
        case 3: return 'ExpiryReminder';
        default: return '';
      }
    },
    field1Label() {
      switch(this.tab) {
        case 0: return this.$t('__trackStatus');
        case 1: return this.$t('__englishText');
        case 2: return this.$t('__managerName');
        case 3: return this.$t('__expirationReminderType');
        default: return '';
      }
    },
    field2Label() {
      switch(this.tab) {
        case 0: return this.$t('__color');
        case 1: return this.$t('__chineseText');
        case 2: return this.$t('__managerMail');
        case 3: return this.$t('__advanceReminderDays');
        default: return '';
      }
    },
    defaultDescription() {
      switch(this.tab) {
        case 0: return 'Track status and color (e.g., #FFFF00)';
        case 1: return 'English and Chinese text';
        case 2: return 'Manager name and email';
        case 3: return 'Days in advance for reminder (default: 30)';
        default: return '';
      }
    }
  },
  methods:{
    exportExcel() {
      var self = this
      var url = this.activeTab === 0 ? '/ExportOrganizationExcel' : '/ExportEmployeeExcel'
      var fileName = this.activeTab === 0 ? 'OrganizationExport.xlsx' : 'EmployeeExport.xlsx'
      this.$http({
        method: 'GET',
        url: url,
        params: { lang: this.language },
        responseType: 'blob'
      }).then(function(response) {
        var blob = response instanceof Blob ? response : (response.data instanceof Blob ? response.data : new Blob([response.data]))
        var disposition = response.headers && response.headers['content-disposition']
        if (disposition) {
          var match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          if (match && match[1]) fileName = match[1].replace(/['"]/g, '')
        }
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
      }).catch((error) => {
        var errorMsg = error.response?.data?.Message || this.$t('__exportFailed')
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      })
    },
    close(){
      this.keyword = ''
      this.memberStatusSel = ''
      this.getDataset()
    },
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-200 + 'px'}
      this.viewStyleTab3 = {height: window.innerHeight-270 + 'px'}
      if(window.innerWidth >= 960){
        this.displayMode = 0
      } else {
        this.displayMode = 1
      }
    },
    redirectPath(id){
      let targetId = (typeof id === 'object' && id !== null) ? (id.encryptedId || id.id) : id
      let tmp = {
        keyword: this.keyword,
        memberStatusSel: this.memberStatusSel,
      }
      sessionStorage.setItem('search',JSON.stringify(tmp))
      var path = ''
      switch(this.activeTab) {
        case 0: path = '/organization'; break;
        case 1: path = '/staff'; break;
        case 2: path = '/customer'; break;
      }
      this.$router.push({path: path, query: {id: targetId, page: this.pagination.page, tab: this.activeTab}})
    },
    setDestPage(){
      let page = parseInt(this.destPage)
      if (isNaN(page) || page < 1) {
        page = 1
      }
      if (page > this.pagination.totalPage) {
        page = this.pagination.totalPage
      }
      this.destPage = page
      if (this.pagination.page === page) {
        this.getDataset()
      } else {
        this.pagination.page = page
      }
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    search(){
      (this.pagination.page == 1) ? this.getDataset() : this.pagination.page = 1
    },
    changeTab(tabIndex) {
      if (this.activeTab === tabIndex) return
      this.activeTab = tabIndex
      sessionStorage.setItem('configTab', tabIndex)
      this.pagination.page = 1
      this.datasets = []
      this.codeTypeList = []
      this.getDataset()
    },
    changeListSel(List){
      for(var i=0; i<List.length; i++){
        if(this.language=='tw'){
          this.$set(List[i], 'content', List[i].twName)
        }else if(this.language=='cn'){
          this.$set(List[i], 'content', List[i].cnName)
        }else if(this.language=='en'){
          this.$set(List[i], 'content', List[i].enName)
        }
      }
    },
    save() {
      if (this.selectedItemIndex == -1) {
        this.$refs.ShowMsg.open(16)
        return
      }
      
      // Validate required fields
      if (!this.editingItem.CodeText || !this.editingItem.CodeValue) {
        this.$refs.ShowMsg.open(1)
        return
      }

      // Email format check for Manager Mail (tab 2)
      if (this.tab === 2) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(this.editingItem.CodeValue)) {
          this.$refs.ShowMsg.open(0, this.$t('__systemHint'), this.$t('__invalidEmail'))
          return
        }
      }

      const normalize = str => (str || '').trim().toLowerCase()
      const normalizedName = normalize(this.editingItem.CodeText)
      const normalizedValue = normalize(this.editingItem.CodeValue)
      // 👉 檢查 CodeText 重複
      const duplicateText = this.codeTypeList.find(item => 
        normalize(item.CodeText) === normalizedName &&
        item.id !== this.editingItem.id
      )
      // 👉 tab = 0：只擋 CodeText
      if (this.tab === 0 && duplicateText) {
        this.$refs.ShowMsg.open(0, this.$t('__systemHint'), this.$t('__duplicateTrackStatus'))
        return
      }
      // 👉 tab = 1：同時檢查 CodeText + CodeValue
      if (this.tab === 1) {
        if (duplicateText) {
          this.$refs.ShowMsg.open(0, this.$t('__systemHint'), this.$t('__duplicateEnglishText'))
          return
        }
        const duplicateValue = this.codeTypeList.find(item => 
          normalize(item.CodeValue) === normalizedValue &&
          item.id !== this.editingItem.id
        )
        if (duplicateValue) {
          this.$refs.ShowMsg.open(0, this.$t('__systemHint'), this.$t('__duplicateChineseText'))
          return
        }
      }

      this.isLoading = true
      var self = this
      
      // Prepare data according to API specification
      var requestData = {
        id: this.editingItem.id || 0,
        CodeType: this.codeTypeKey,
        OrderSeq: this.editingItem.OrderSeq || 1,
        CodeText: this.editingItem.CodeText,
        CodeValue: this.editingItem.CodeValue,
        CodeMemo1: this.editingItem.CodeMemo1 || this.defaultDescription,
        CodeMemo2: this.editingItem.CodeMemo2 || '',
        CodeMemo3: this.editingItem.CodeMemo3 || '',
        CodeMemo4: this.editingItem.CodeMemo4 || '',
        CodeMemo5: this.editingItem.CodeMemo5 || ''
      }

      var request = {
        method: 'POST',
        url: '/SetCodeType',
        headers: {
          'Content-Type': 'application/json'
        },
        data: requestData
      }

      this.$http(request).then(function(response) {
        self.$refs.ShowMsg.open(0, i18n.t('__savedSuccessfully'), response.data.Message || 'Saved successfully')
        self.isLoading = false
        self.selectedItemIndex = -1
        self.getCodeTypeList()
      }).catch((error) => {
        console.error('Save error:', error)
        var errorMsg = error.response?.data?.Message || 'Save failed'
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
        self.isLoading = false
      })
    },
    getDataset(){
      var self = this
      this.isLoading = true
      if(this.activeTab !== 3) {
        this.datasets = []
        var url = ''
        var params = {
          'orderBy': self.orderBy,
          'direction': self.direction,
          'pageSize': self.pageSize,
          'currentPage': self.pagination.page,
          'keyword':self.keyword != ''? self.keyword: null,
        }

        switch(this.activeTab) {
          case 0: url = '/GetOrganizationList'; break;
          case 1: url = '/AllEmployeeList'; break;
          case 2: url = '/GetCustomerList'; break;
        }
        
        var request = {
          method: 'GET',
          url: url,
          params: params,
        }

        if(this.activeTab === 1) { // Employee
          if(self.memberStatusSel) {
            request.params.status = self.memberStatusSel
          }
        }

        this.$http(request).then(function(response) {
          if(response.data.Data) {
            self.datasets = response.data.Data
            self.pagination.totalPage = response.data.TotalPageCount || 1
            self.pagination.totalCount = response.data.TotalCount || 0
          } else if (response.data.data && response.data.data.records) {
            self.datasets = response.data.data.records
            self.pagination.totalPage = response.data.data.pages || 1
            self.pagination.totalCount = response.data.data.total || 0
          }
        }).catch(()=>{
          self.datasets = []
        }).finally(() => {
          self.isLoading = false
        })
      } else {
        // Config Tab (CodeType Management)
        this.getCodeTypeList()
      }
    },
    getCodeTypeList() {
      var self = this
      this.isLoading = true
      this.codeTypeList = []
      var request = {
        method: 'GET',
        url: '/CodeTypeList',
        params: {
          CodeType: this.codeTypeKey,
          pagesize: 9999,
          currentPage: 1,
        }
      }
      this.$http(request).then(function(response) {
        if(response.data.Data) {
          self.codeTypeList = response.data.Data
        } else if (response.data.data) {
          self.codeTypeList = response.data.data
        } else if(Array.isArray(response.data)) {
          self.codeTypeList = response.data
        } else {
          self.codeTypeList = []
        }
        // Reset selection when list changes
        self.selectedItemIndex = -1
      }).catch(()=>{
        self.codeTypeList = []
        self.selectedItemIndex = -1
      }).finally(() => {
        self.isLoading = false
      })
    },
    addNewItem() {
      // Clear selection and set up new item
      this.selectedItemIndex = 99999  // Indicate we're editing a "new" item
      this.editingItem = {
        id: 0,
        CodeType: this.codeTypeKey,
        OrderSeq: this.codeTypeList.length + 1,
        CodeText: '',
        CodeValue: '',
        CodeMemo1: this.defaultDescription,
        CodeMemo2: '',
        CodeMemo3: '',
        CodeMemo4: '',
        CodeMemo5: ''
      }
    },
    openColorPicker() {
      this.$nextTick(() => {
        if (this.$refs.nativeColorPicker) {
          this.$refs.nativeColorPicker.click()
        }
      })
    },
    onColorPickerChange(event) {
      this.editingItem.CodeValue = event.target.value.toUpperCase()
    },
    selectItem(index) {
      this.selectedItemIndex = index
      // Deep copy the item to editing state
      this.editingItem = JSON.parse(JSON.stringify(this.codeTypeList[index]))
    },
    confirmDeleteItem(id) {
      this.deleteId = id
      this.$refs.ShowConfirm.open(2, null, null, true)
    },
    deleteCodeTypeItem() {
      if (!this.deleteId) return
      
      var self = this
      var request = {
        method: 'DELETE',
        url: '/DeleteCode',
        params: { id: this.deleteId }
      }
      this.$http(request).then(function(response) {
        self.$refs.ShowMsg.open(0, i18n.t('__deleteSuccess'), response.data.Message || 'Deleted successfully')
        self.deleteId = null
        self.selectedItemIndex = -1
        self.getCodeTypeList()
      }).catch((error) => {
        console.error('Delete error:', error)
        var errorMsg = error.response?.data?.Message || 'Delete failed'
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
        self.deleteId = null
      })
    },
    confirmDelete(id) {
      // Store the ID and show confirmation dialog
      this.deleteId = id
      this.$refs.ShowConfirm.open(2, null, null, true)
    },
    deleteRecord() {
      if (!this.deleteId) return
      
      // For Config tab (activeTab === 3), use CodeType deletion
      if (this.activeTab === 3) {
        this.deleteCodeTypeItem()
        return
      }
      
      var self = this
      var url = ''
      switch(this.activeTab) {
        case 0: url = '/DeleteOrganization'; break;
        case 1: url = '/DeleteEmployee'; break;
        case 2: url = '/DeleteCustomer'; break;
      }
      
      var request = {
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json-patch+json'
        },
        data: {
          id: this.deleteId
        }
      }
      
      this.$http(request).then(function(response) {
        var res = response.data
        if (res.State === '9885') {
          var msg = res.Message || self.$t('__hasPendingCases')
          self.$refs.ShowMsg.open(0, self.$t('__error'), msg)
          self.deleteId = null
          return
        }
        
        // Reset delete ID
        self.deleteId = null
        
        // Refresh the list
        self.getDataset()
        
        // Show success message using ShowMsg component
        self.$refs.ShowMsg.open(4) // type 4 = delete success
      }).catch((error) => {
        console.error('Delete error:', error)
        var errorMsg = error.response?.data?.Message || this.$t('__deleteFailed')
        // Show error message using ShowMsg component
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
        self.deleteId = null
      })
    },
    onImportFile(){
      this.getDataset()
    },
  },
}
</script>

<style scoped>
  @media (min-width: 960px) {
    .search-bar-min {
      display: none !important;
    }
  }
  @media (max-width: 959px) {
    .search-bar-max, .pagination-max {
      display: none !important;
    }
  }
  
  /* Action buttons hover effects */
  .action-btn-edit:hover {
    opacity: 0.8;
    transition: opacity 0.2s;
  }
  
  .action-btn-delete:hover {
    opacity: 0.8;
    transition: opacity 0.2s;
  }
  
  .orange-row { background-color: #FFF3E0 !important; outline: 2px solid #ED6D00 }
  .orange-row:hover { background-color: #FFE0B2 !important }
  .orange-row td:first-child { border-left: 2px solid #ED6D00 }
  .orange-row td:last-child { border-right: 2px solid #ED6D00  }

  .disabled-row {
    background-color: #EEEEEE !important;
    color: #999 !important;
  }
  
  .disabled-row:hover {
    background-color: #E2E2E2 !important;
  }
 
  #box .v-data-table >>> thead tr {
    background: #FFFFFF !important;
  }
  #box .v-data-table >>> thead th {
    background-color: transparent !important;
  }

  #box .v-textarea >>> .v-input__control {
    height: auto !important;
  }
  #box .v-textarea >>> fieldset {
    height: auto !important;
  }
 
  #box2 .v-data-table >>> thead tr {
    background: #FFFFFF !important;
  }
  #box2 .v-data-table >>> thead th {
    background-color: transparent !important;
  }
  #box2 .v-textarea >>> .v-input__control {
    height: auto !important;
  }
  #box2 .v-textarea >>> fieldset {
    height: auto !important;
  }

  /* Fixed footer styles for Config Tab */
  .fixed-footer {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 4 !important; /* Sidebar in Home.vue is z-index 5 */
    background: white !important;
    box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.06) !important;
    padding: 13.5px 0px !important;
  }

  .centered-input >>> input {
    text-align: center;
  }
  .centered-input >>> input[type=number] {
    -moz-appearance: textfield;
  }
</style>